export function getTeamColor(teamName: string): string {
  // Premier hash (djb2)
  let hash1 = 5381;
  for (let i = 0; i < teamName.length; i++) {
    hash1 = ((hash1 << 5) + hash1) + teamName.charCodeAt(i);
  }
  // Second hash sur le nom inversé
  let hash2 = 52711;
  for (let i = teamName.length - 1; i >= 0; i--) {
    hash2 = ((hash2 << 5) - hash2) + teamName.charCodeAt(i);
  }
  // Combine les deux pour plus de dispersion
  const hue = Math.abs((hash1 ^ hash2) % 360);
  const sat = 55 + Math.abs(hash2 % 40); // 55-95%
  const light = 45 + Math.abs(hash1 % 30); // 45-75%
  return `hsl(${hue}, ${sat}%, ${light}%)`;
}